<section class="companion-section">
  <div class="companion-field-grid">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Delay (seconds)</mat-label>
      <mat-select [formControl]="delay">
        <mat-option *ngFor="let option of delayOptions" [value]="option">
          {{ option | number: "1.1-1" }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="ValidationHelperService.isInvalid(delay)">
        {{ ValidationHelperService.getErrorMessage(delay) }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Prompt</mat-label>
      <mat-select [formControl]="timerPrompt">
        <mat-option *ngFor="let option of promptOptions" [value]="option">
          {{ option === 0 ? "Solid" : (option | number: "1.1-1") }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="ValidationHelperService.isInvalid(timerPrompt)">
        {{ ValidationHelperService.getErrorMessage(timerPrompt) }}
      </mat-error>
    </mat-form-field>
  </div>
  <mat-error class="companion-error" *ngIf="hasGoNoGoPromptError">
    Go / No Go requires a prompt greater than zero.
  </mat-error>
  <mat-error class="companion-error" *ngIf="hasStroopSolidPromptError">
    Solid prompt cannot be used with Stroop when Neurocognitive is Off.
  </mat-error>
</section>

<section class="companion-section" *ngIf="isolatedReact.value">
  <h4 class="companion-section__title">Active Sensors</h4>
  <p class="companion-section__hint">
    Yellow sensors are active; red sensors are inactive.
  </p>
  <div
    class="max-w-[600px] mx-auto border grid grid-cols-3 grid-rows-3 items-center justify-center content-center w-full h-auto [&>*]:aspect-square bg-[#3E3E3E] rounded-3xl"
  >
    <div class="w-full h-full flex justify-center items-center">
      <button
        type="button"
        class="toggle-circle flex justify-center items-center bg-amber-300 font-bold text-white content-center"
        matRipple
        (click)="setSensor(0)"
        [class.bg-red-500]="!reactSensors.value[0]"
        [attr.aria-pressed]="reactSensors.value[0]"
        aria-label="Sensor 1"
      >
        1
      </button>
    </div>
    <div></div>
    <div class="w-full h-full flex justify-center items-center">
      <button
        type="button"
        matRipple
        class="toggle-circle flex justify-center items-center bg-amber-300 font-bold text-white"
        (click)="setSensor(1)"
        [class.bg-red-500]="!reactSensors.value[1]"
        [attr.aria-pressed]="reactSensors.value[1]"
        aria-label="Sensor 2"
      >
        2
      </button>
    </div>
    <div></div>
    <div class="w-full h-full flex justify-center items-center">
      <button
        type="button"
        matRipple
        class="toggle-circle flex justify-center items-center bg-amber-300 font-bold text-white"
        (click)="setSensor(2)"
        [class.bg-red-500]="!reactSensors.value[2]"
        [attr.aria-pressed]="reactSensors.value[2]"
        aria-label="Sensor 3"
      >
        3
      </button>
    </div>
    <div></div>
    <div class="w-full h-full flex justify-center items-center">
      <button
        type="button"
        matRipple
        class="toggle-circle flex justify-center items-center bg-amber-300 font-bold text-white"
        (click)="setSensor(3)"
        [class.bg-red-500]="!reactSensors.value[3]"
        [attr.aria-pressed]="reactSensors.value[3]"
        aria-label="Sensor 4"
      >
        4
      </button>
    </div>
    <div></div>
    <div class="w-full h-full flex justify-center items-center">
      <button
        type="button"
        matRipple
        class="toggle-circle flex justify-center items-center bg-amber-300 font-bold text-white"
        (click)="setSensor(4)"
        [class.bg-red-500]="!reactSensors.value[4]"
        [attr.aria-pressed]="reactSensors.value[4]"
        aria-label="Sensor 5"
      >
        5
      </button>
    </div>
  </div>
  <mat-error class="companion-error" *ngIf="hasActiveSensorsError">
    At least one active sensor must be selected when Isolated React is On.
  </mat-error>
</section>

<section class="companion-section">
  <div class="companion-color-picker">
    <h4 class="companion-section__title">React to</h4>
    <div class="companion-color-grid">
      <button
        type="button"
        class="react-option"
        *ngFor="let color of colorOptions; let i = index"
        [ngClass]="color.className"
        [class.full-opacity]="react[i]"
        [attr.aria-label]="'React to ' + color.name"
        [attr.aria-pressed]="react[i]"
        [title]="color.name"
        (click)="setReact(i, 1)"
        matRipple
      >
        <i class="material-icons react-overlay-icon" *ngIf="react[i]"> done </i>
      </button>
    </div>
  </div>
  <div
    class="text-red-500 text-sm mt-1"
    *ngIf="ValidationHelperService.isInvalid(reactTo)"
  >
    {{ ValidationHelperService.getErrorMessage(reactTo) }}
  </div>
  <mat-error
    class="companion-error"
    *ngIf="_formGroup.touched && _formGroup.errors?.['invalidReactColorCount']"
  >
    Off and Array require exactly one React color.
  </mat-error>
  <mat-error
    class="companion-error"
    *ngIf="_formGroup.touched && _formGroup.errors?.['invalidGoNoGoColors']"
  >
    Go / No Go requires at least one React and one Don't React color.
  </mat-error>
</section>

<section class="companion-section" *ngIf="neurocognitiveType.value !== 0">
  <div class="companion-color-picker">
    <h4 class="companion-section__title">Don't React to</h4>
    <div class="companion-color-grid">
      <button
        type="button"
        class="react-option"
        *ngFor="let color of colorOptions; let i = index"
        [ngClass]="color.className"
        [class.full-opacity]="dontReact[i]"
        [attr.aria-label]="'Do not react to ' + color.name"
        [attr.aria-pressed]="dontReact[i]"
        [title]="color.name"
        (click)="setReact(i, 2)"
        matRipple
      >
        <i class="material-icons react-overlay-icon" *ngIf="dontReact[i]">
          done
        </i>
      </button>
    </div>
  </div>
  <div
    class="text-red-500 text-sm mt-1"
    *ngIf="ValidationHelperService.isInvalid(dontReactTo)"
  >
    {{ ValidationHelperService.getErrorMessage(dontReactTo) }}
  </div>
</section>

<section class="companion-section">
  <h4 class="companion-section__title">Companion Communication Type</h4>
  <mat-tab-group
    class="custom-tab-group custom-tab-group--selector"
    [selectedIndex]="communicationType.value"
    (selectedTabChange)="onCommunicationTabChange($event)"
  >
    <mat-tab label="Alternate"></mat-tab>
    <mat-tab label="Random"></mat-tab>
  </mat-tab-group>
</section>

<section class="companion-section">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Neurocognitive</mat-label>
      <mat-select [formControl]="neurocognitiveType">
        <mat-option [value]="0">Off</mat-option>
        <mat-option [value]="2">Go / No Go</mat-option>
        <mat-option [value]="1">Array</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Stroop Effect</mat-label>
      <mat-select [formControl]="stroopEffectType">
        <mat-option [value]="0">None</mat-option>
        <mat-option [value]="1">Congruent</mat-option>
        <mat-option [value]="2">Incongruent</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Isolated React</mat-label>
      <mat-select
        [formControl]="isolatedReact"
        (selectionChange)="resetReact()"
      >
        <mat-option [value]="false">Off</mat-option>
        <mat-option [value]="true">On</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</section>
